import LanguagePackEntries from './languagePackEntries';

const resolveLanguagePackKey = (
  pageConfig,
  key,
) => {
  const languagePackEntries = pageConfig?.languagePack?.entries ?? {};
  const entry = LanguagePackEntries[key];
  return languagePackEntries[entry.languagePackKey] ?? entry.fallbackValue;
};

export default resolveLanguagePackKey;
